<template>
  <div id="app" class="h-p100">
    <!--          必须加上可以，不然同页面跳转不会刷新页面-->
    <router-view/>
  </div>
</template>

<script>
import myConst from "./util/my-const";

export default {
  name: "App",
  methods: {
    // updateScale() {
    //   let ww = window.innerWidth;
    //   let wh = window.innerHeight;
    //   let wrapW = this.$refs.divWrap.clientWidth;
    //   let wrapH = this.$refs.divWrap.clientHeight;
    //   let scaleW = ww / wrapW;
    //   let scaleH = wh / wrapH;
    //   this.$refs.divWrap.style.transform = "scale(" + scaleW + "," + scaleH + ")";
    //   console.log("ww：" + ww + "，wh：" + wh + "，wrapw：" + wrapW + "，wrapH：" + wrapH + "，scaleW：" + scaleW + "，scaleH：" + scaleH);
    //   // ww：881，wh：625，wrapw：881，wrapH：625，scaleW：1，scaleH：1
    // }
  },
  created() {
    // let scaleInt = setInterval(this.updateScale, 2000)

    //解决刷新页面stort数据丢失，但是无法实现多个页面数据共享
    //在页面加载时读取sessionStorage里的状态信息
    if (sessionStorage.getItem(myConst.keyStore)) {
      this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(sessionStorage.getItem(myConst.keyStore))));
    }

    //在页面刷新时将vuex里的信息保存到sessionStorage里
    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem(myConst.keyStore, JSON.stringify(this.$store.state));
    })
  },
}
</script>

<style scoped>

</style>
